import React, { useEffect, useRef, useState } from "react";
import "./AddProduct.scss";

import { BsStarFill } from "react-icons/bs";

import { useForm } from "react-hook-form";
import InputField from "../../../components/InputField/InputField";
import InputSelect from "../../../components/InputSelect/InputSelect";
import CustomButton from "../../../components/CustomButton/CustomButton";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import Accordian from "../../../components/Accordian/Accordian";
import { useDispatch, useSelector } from "react-redux";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import {
  addProduct,
  deleteProduct,
  fetchProductActivities,
  updateProduct,
} from "../../../api/products";
import { toast } from "react-toastify";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";

import ROUTES from "../../../constants/routes";
import useOrganizationIsAllowed from "../../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { fetchProductData } from "../../../redux/features/home-slice";
import {
  deleteExistingProduct,
  updateExistingProduct,
} from "../../../redux/features/products-slice";
import { addCategory } from "../../../api/categories";
import { addNewCategory } from "../../../redux/features/organization-slice";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import useUserIsAllowed from "../../../helpers/userAuthorized";
import { IoMdCloseCircle } from "react-icons/io";
import { FaAngleRight, FaArrowUpLong, FaPlus } from "react-icons/fa6";
import { FaCaretDown, FaCaretUp, FaCheck, FaMinus } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { RiLoaderLine } from "react-icons/ri";
import { BiSolidErrorCircle } from "react-icons/bi";
import { TbHourglassEmpty } from "react-icons/tb";
import { format, isToday, isYesterday, parseISO } from "date-fns";
import { fetchSaleDetails } from "../../../api/sales";
import PDF from "../../PDF/PDF";
import Customer from "../../Customer/Customer";
import AddCustomer from "../../Customer/AddCustomer/AddCustomer";
import SalesDetails from "../../Sales/SalesDetails/SalesDetails";
import ImageInput from "../../../components/ImageInput/ImageInput";

const AddProduct = ({ isEdit, desktopView, item, setSelectedProduct }) => {
  const { currentViewPort, isReady } = useViewPortDetector();
  const location = useLocation();
  const navigate = useNavigate();

  const { id: organization_id, categories } = useSelector(
    (state) => state.organizationReducer.value
  );

  const { run } = useSelector((state) => state.tourReducer.value);

  const { id: branch_id, branches } = useSelector(
    (state) => state.branchReducer.value
  );
  const dispatch = useDispatch();

  const [openAddCategory, setOpenAddCategory] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    formState: { errors, isDirty },
  } = useForm({});

  const priceWatch = watch("price");

  const scrollToTopRef = useRef(null);

  const [productId, setProductId] = useState(null);
  const [product, setProduct] = useState(null);
  const [selectedTab, setSelectedTab] = useState("product");
  const [price, setPrice] = useState({
    actual_price: 0,
    reduced_price: 0,
  });

  const [image, setImage] = useState({
    src: null,
    file: null,
  });

  const sellByOptions = [
    {
      label: "Unit",
      value: "Unit",
    },
    {
      label: "Kg",
      value: "Kg",
    },
    {
      label: "Inches",
      value: "Inches",
    },
  ];

  const [tabs, setTabs] = useState(["product", "stock"]);

  const [selectedSellBy, setSelectedSellBy] = useState(sellByOptions[0]);
  const [selectedCategories, setSeletedCategories] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [openCategory, setOpenCategory] = useState(false);

  const [saleId, setSaleId] = useState(null);

  const orgIsAllowedToManageStock =
    useOrganizationIsAllowed("stock_management");

  const orgIsAllowedToAddProductImage = useOrganizationIsAllowed(
    "upload_product_photo"
  );

  const userIsAllowedToCreateOrEditProducts = useUserIsAllowed(
    "create_or_edit_products"
  );

  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToDeleteProduct =
    userIsAdministrator || userIsAllowedToManageInventory;

  useEffect(() => {
    if (!desktopView) {
      if (currentViewPort === "desktop" && isReady) {
        navigate(ROUTES.manageProduct.path);
      }
    }
  }, [currentViewPort, desktopView, isReady]);

  useEffect(() => {
    setSelectedTab("product");
    if (isEdit) {
      setTabs(["product", "stock", "activity"]);
    } else {
      setTabs(["product", "stock"]);
    }
  }, [isEdit]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty]);

  useBlocker(({ currentLocation, nextLocation }) => {
    if (isDirty && currentLocation.pathname !== nextLocation.pathname) {
      return !window.confirm(
        "You have unsaved changes. Do you really want to leave?"
      );
    }
    return false;
  }, isDirty);

  const clearForm = () => {
    setProductId(null);
    setProduct(null);
    reset({
      name: "",
      price: "",
      reduced_price: "",
      description: "",
      bar_code: "",
      sell_by: "Unit",
      categories: [],
      highlight: false,
      catalog: false,
    });

    branches.forEach((branch) => {
      reset((pre) => ({
        ...pre,
        [`current_stock_${branch?.id}`]: "",
        [`min_quantity_${branch?.id}`]: "",
      }));
    });

    setPrice({
      actual_price: 0,
      reduced_price: 0,
    });

    setSelectedSellBy(sellByOptions[0]);
    setImage({
      file: null,
      src: null,
    });
    setSeletedCategories([]);
  };

  useEffect(() => {
    const editData =
      isEdit && desktopView ? item : isEdit ? location.state?.editData : {};
    if (isEdit) {
      if (!editData?.id) {
        !desktopView && navigate(ROUTES.manageProduct.path);
        clearForm();
      } else {
        setProductId(editData?.id);
        setProduct({
          ...editData,
          current_stock:
            editData?.branch_stocks?.find((el) => el?.branch_id === branch_id)
              ?.current_stock || 0,
        });
        const initialValues = {
          name: editData?.name,
          price: editData?.price,
          reduced_price: editData?.reduced_price,
          description: editData?.description,
          bar_code: editData?.bar_code,
          sell_by: editData?.sell_by,
          categories: editData?.categories?.map((el) => el?.id),
          highlight: editData?.highlight ? true : false,
          catalog: editData?.catalog ? true : false,
          ...branches?.reduce((acc, branch) => {
            const exists = editData?.branch_stocks?.find(
              (el) => el?.branch_id === branch?.id
            );
            acc[`current_stock_${branch?.id}`] = exists?.current_stock || "";
            acc[`min_quantity_${branch?.id}`] = exists?.min_quantity || "";
            return acc;
          }, {}),
        };

        reset(initialValues);

        setPrice({
          actual_price: editData?.price || 0,
          reduced_price: editData?.reduced_price || 0,
        });

        if (editData?.sell_by) {
          setSelectedSellBy({
            label: editData?.sell_by,
            value: editData?.sell_by,
          });
        } else {
          setSelectedSellBy(sellByOptions[0]);
        }

        if (editData?.image) {
          setImage({
            file: null,
            src: `${editData?.image}`,
          });
        } else {
          setImage({
            file: null,
            src: null,
          });
        }

        if (editData?.categories?.length) {
          const options = [];
          editData?.categories?.map((item) => {
            let foundItem = categories?.find(
              (el) => el?.id === item?.pivot?.category_id
            );
            if (foundItem) {
              options.push(foundItem);
            }
          });
          setSeletedCategories(options);
        } else {
          setSeletedCategories([]);
        }
      }
    } else {
      clearForm();
    }
  }, [isEdit, location, item]);

  useEffect(() => {
    const editData =
      isEdit && desktopView ? item : isEdit ? location.state?.editData : {};

    if (editData?.categories?.length) {
      const options = [];
      editData?.categories?.map((item) => {
        let foundItem = categories?.find(
          (el) => el?.id === item?.pivot?.category_id
        );
        if (foundItem) {
          options.push(foundItem);
        }
      });
      setSeletedCategories(options);
    } else {
      setSeletedCategories([]);
    }
  }, [categories]);

  const handleProductSubmit = (data) => {
    let ready = false;
    if (
      selectedTab === "product" &&
      orgIsAllowedToManageStock.exists &&
      !isEdit
    ) {
      setSelectedTab("stock");
    } else {
      ready = true;
    }

    if (ready && organization_id) {
      setSubmitting(true);

      const categoriesList = selectedCategories?.map((el) => el.id);

      const productData = new FormData();
      if (image.file) {
        productData.append("image", image.file);
      } else if (!image.src) {
        productData.append("image_remove", true);
      }
      productData.append("name", data.name);
      productData.append("price", data.price);
      productData.append("reduced_price", data.reduced_price);
      productData.append("description", data.description);
      productData.append("bar_code", data.bar_code);
      productData.append("sell_by", selectedSellBy?.value);
      productData.append("highlight", data.highlight);
      productData.append("catalog", data.catalog);
      productData.append("organization_id", organization_id);

      categoriesList.forEach((el) => {
        productData.append("categories[]", el);
      });

      const stockData = [];

      branches?.forEach((branch) => {
        if (
          data[`current_stock_${branch?.id}`] ||
          data[`min_quantity_${branch?.id}`]
        ) {
          stockData.push({
            branch_id: branch?.id,
            current_stock: Number(data[`current_stock_${branch?.id}`] || 0),
            min_quantity: Number(data[`min_quantity_${branch?.id}`] || 0),
          });
        }
      });

      if (stockData.length === 0) {
        stockData.push({
          branch_id: branch_id,
          current_stock: 0,
          min_quantity: 0,
        });
      }

      productData.append("stock_data", JSON.stringify(stockData));

      if (isEdit) {
        updateProduct(productId, productData)
          .then((res) => {
            if (res.data?.product) {
              dispatch(
                updateExistingProduct({ products: [res.data?.product] })
              );
            }
            clearForm();
            setSelectedProduct && setSelectedProduct(null);
            setSelectedTab("product");
            toast.dismiss();
            toast.success("Product updated successfully.");
            navigate(ROUTES.manageProduct.path);
            if (data?.highlight) {
              dispatch(
                fetchProductData({
                  organization_id: organization_id,
                  branch_id: branch_id,
                })
              );
            }
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss();
                toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss();
              toast.error("Error while updating product.");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        addProduct(productData)
          .then((res) => {
            if (res.data?.product) {
              dispatch(
                updateExistingProduct({ products: [res.data?.product] })
              );
            }
            clearForm();
            setSelectedProduct && setSelectedProduct(null);
            toast.dismiss();
            toast.success("Product added successfully.");
            setSelectedTab("product");
            navigate(ROUTES.manageProduct.path);
            if (data.highlight) {
              dispatch(
                fetchProductData({
                  organization_id: organization_id,
                  branch_id: branch_id,
                })
              );
            }
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              if (err?.response?.data?.message === "User not authorized!") {
                toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
              } else {
                toast.dismiss();
                toast.error(`${err?.response?.data?.message}`);
              }
            } else {
              toast.dismiss();
              toast.error("Error while adding product.");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  useEffect(() => {
    if (scrollToTopRef.current) {
      scrollToTopRef.current.scrollTo(0, 0);
    }
  }, [selectedTab]);

  const handleDelete = () => {
    setDeleting(true);
    if (productId) {
      deleteProduct(productId)
        .then((res) => {
          dispatch(deleteExistingProduct({ product_id: productId }));
          clearForm();
          setSelectedProduct && setSelectedProduct(null);
          toast.dismiss();
          toast.success("Product deleted successfully.");
          setOpenDelete(false);
          navigate(ROUTES.manageProduct.path);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
              toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss();
              toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss();
            toast.error("Error while deleting product.");
          }
        })
        .finally(() => {
          setDeleting(false);
        });
    }
  };

  useEffect(() => {
    if (Number(price.reduced_price) > Number(price.actual_price)) {
      setError("reduced_price", {
        type: "custom",
        message: "Reduced price cannot be greater than above Price.",
      });
    } else {
      clearErrors("reduced_price");
    }
  }, [price]);

  const handleSubmitClick = () => {
    setTimeout(() => {
      if (
        selectedTab === "product" &&
        !errors["name"] &&
        !errors["price"] &&
        !errors["reduced_price"] &&
        !errors["sell_by"]
      ) {
        if (!isEdit) {
          setSelectedTab("stock");
        }
      } else {
        setSelectedTab("product");
      }
    }, 500);
  };

  return (
    <>
      <div className="add-product">
        <div className="top-tab">
          {tabs.map((item, i) => {
            return (
              <div
                className={selectedTab === item && "active"}
                key={i}
                id={item === "product" ? "tour-product-tag" : "tour-stock-tag"}
                onClick={() => {
                  if (
                    !orgIsAllowedToManageStock.exists &&
                    (item === "stock" || item === "activity")
                  ) {
                    dispatch(updateOpenSubscriptionAd({ openAd: true }));
                  } else {
                    if (selectedTab !== item) {
                      setSelectedTab(item);
                    }
                  }
                }}
              >
                <p>{item}</p>
              </div>
            );
          })}
        </div>

        <form
          ref={scrollToTopRef}
          onSubmit={handleSubmit(handleProductSubmit)}
          className={`form-slider ${
            selectedTab === "stock"
              ? "second"
              : selectedTab === "activity"
              ? "third"
              : ""
          } ${tabs.length === 3 ? "three" : ""}`}
        >
          <div className="product slides container-wrapper">
            <div className="input-container static">
              <ImageInput
                image={image}
                setImage={setImage}
                label={"Product Image"}
                featureAvailable={orgIsAllowedToAddProductImage.exists}
                isAllowed={userIsAllowedToCreateOrEditProducts}
              />

              <InputField
                name={"name"}
                type={"text"}
                label={"Product Name"}
                required={true}
                register={register}
                inputErrors={errors}
                watch={watch}
                disabled={!userIsAllowedToCreateOrEditProducts}
              />

              <InputField
                name={"price"}
                type={"number"}
                label={"Product Price"}
                required={true}
                register={register}
                inputErrors={errors}
                watch={watch}
                handleChange={(value) => {
                  setPrice({ ...price, actual_price: value });
                }}
                constraints={{
                  min: 0.01,
                }}
                disabled={!userIsAllowedToCreateOrEditProducts}
              />
            </div>

            <Accordian name={"Details (optional)"} initial={true && !run}>
              <div className="input-container">
                <InputField
                  name={"reduced_price"}
                  type={"number"}
                  label={"Reduced Price"}
                  required={false}
                  register={register}
                  inputErrors={errors}
                  watch={watch}
                  handleChange={(value) => {
                    setPrice({ ...price, reduced_price: value });
                  }}
                  constraints={{
                    max: priceWatch,
                  }}
                  disabled={!userIsAllowedToCreateOrEditProducts}
                />

                <InputField
                  name={"description"}
                  type={"text"}
                  label={"Description"}
                  textArea={true}
                  required={false}
                  register={register}
                  inputErrors={errors}
                  watch={watch}
                  disabled={!userIsAllowedToCreateOrEditProducts}
                />

                <InputField
                  name={"bar_code"}
                  type={"text"}
                  label={"Bar Code"}
                  required={false}
                  register={register}
                  inputErrors={errors}
                  watch={watch}
                  disabled={!userIsAllowedToCreateOrEditProducts}
                />

                <InputSelect
                  options={sellByOptions}
                  value={selectedSellBy}
                  register={register}
                  required={true}
                  name="sell_by"
                  handleChange={(opt) => {
                    setSelectedSellBy(opt);
                  }}
                  reset={reset}
                  label={"Sell By"}
                  inputErrors={errors}
                  disabled={!userIsAllowedToCreateOrEditProducts}
                />

                <div
                  className="select-category-options"
                  onClick={() => {
                    setOpenCategory(true);
                  }}
                >
                  <label
                    className={selectedCategories?.length > 0 ? "active" : ""}
                    htmlFor="categories"
                  >
                    Categories
                  </label>
                  <input type="text" {...register("categories")} />
                  <p>
                    {selectedCategories?.map((el, i) => {
                      const needsComma =
                        selectedCategories?.length > 1 &&
                        i !== selectedCategories?.length - 1;
                      return (
                        <span key={i}>
                          {el?.name}
                          {needsComma ? ", " : ""}
                        </span>
                      );
                    })}
                  </p>
                  <FaAngleRight />
                </div>

                <ToggleSwitch
                  name={"highlight"}
                  label={"Highlight this product"}
                  register={register}
                  required={false}
                  SVG={BsStarFill}
                  disabled={!userIsAllowedToCreateOrEditProducts}
                />

                <ToggleSwitch
                  name={"catalog"}
                  label={"Show in your catalog"}
                  register={register}
                  required={false}
                  disabled={!userIsAllowedToCreateOrEditProducts}
                />
              </div>
            </Accordian>

            <div className="buttons">
              <CustomButton
                name={
                  orgIsAllowedToManageStock.exists
                    ? isEdit
                      ? "Update Product"
                      : "Next"
                    : isEdit
                    ? "Update Product"
                    : "Add Product"
                }
                color={"primary"}
                type={"submit"}
                handleSubmit={() => {
                  handleSubmitClick();
                }}
                disabled={submitting || !userIsAllowedToCreateOrEditProducts}
                bigButton={true}
                id={"tour-add-product-button"}
                loader={submitting}
              />

              {(isEdit || run) && (
                <CustomButton
                  name={"Delete Product"}
                  color={"danger"}
                  type={"button"}
                  handleSubmit={() => {
                    if (isEdit) {
                      setOpenDelete(true);
                    }
                  }}
                  disabled={submitting || !userIsAllowedToDeleteProduct}
                  bigButton={true}
                  id={"tour-delete-product-button"}
                />
              )}
            </div>
          </div>

          <div className="stock slides container-wrapper">
            {branches?.map((branch, i) => {
              return (
                <div className="input-container static" key={i}>
                  <p className="heading">Branch: {branch?.name}</p>
                  <InputField
                    name={`current_stock_${branch?.id}`}
                    type={"number"}
                    label={"On Hand"}
                    required={false}
                    register={register}
                    inputErrors={errors}
                    watch={watch}
                    constraints={
                      !isEdit
                        ? {
                            min: 0,
                          }
                        : {}
                    }
                    disabled={!userIsAllowedToCreateOrEditProducts}
                  />
                  <InputField
                    name={`min_quantity_${branch?.id}`}
                    type={"number"}
                    label={"Minimum Quantity"}
                    required={false}
                    register={register}
                    inputErrors={errors}
                    watch={watch}
                    constraints={{
                      min: 0,
                    }}
                    disabled={!userIsAllowedToCreateOrEditProducts}
                  />
                </div>
              );
            })}
            <div className="buttons">
              <CustomButton
                name={isEdit ? "Update Product" : "Add Product"}
                color={"primary"}
                type={"submit"}
                handleSubmit={() => {
                  handleSubmitClick();
                }}
                disabled={submitting || !userIsAllowedToCreateOrEditProducts}
                bigButton={true}
                loader={submitting}
              />
            </div>
          </div>

          {isEdit ? (
            <div className="activity slides container-wrapper">
              <div className={`product-item`}>
                <div className="image">
                  <p>
                    {`${product?.name}`.length > 0
                      ? `${product?.name}`[0]
                      : "P"}
                  </p>
                  {product?.image && (
                    <img
                      src={`${product.image}`}
                      alt=""
                      aria-label={`${product?.name || "Product"}'s Image`}
                    />
                  )}
                </div>
                <div className="content">
                  <p className="name">{product?.name}</p>
                  {orgIsAllowedToManageStock ? (
                    <p className="stock">{product?.current_stock}</p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <ProductActivity
                productId={productId}
                branchId={branch_id}
                orgIsAllowed={orgIsAllowedToManageStock}
                setSaleId={setSaleId}
              />
            </div>
          ) : (
            <></>
          )}
        </form>
        <AddCategory
          openAddCategory={openAddCategory}
          setOpenAddCategory={setOpenAddCategory}
          organizationId={organization_id}
        />

        <CategorySelectionModel
          open={openCategory}
          setOpen={setOpenCategory}
          options={categories}
          selectedOptions={selectedCategories}
          setOpenAddCategory={setOpenAddCategory}
          setSelectedOptions={setSeletedCategories}
        />

        {isEdit ? (
          <SalesDetailsModel
            saleId={saleId}
            setSaleId={setSaleId}
            branchId={branch_id}
          />
        ) : (
          <></>
        )}

        {openAddCategory && (
          <div
            className="blur-back"
            onClick={() => {
              setOpenAddCategory(false);
            }}
          ></div>
        )}

        {openCategory && (
          <div
            className="blur-back lower"
            onClick={() => {
              setOpenCategory(false);
            }}
          ></div>
        )}
      </div>
      <DeleteModal
        name={"Product"}
        deleting={deleting}
        open={openDelete}
        setOpen={setOpenDelete}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default AddProduct;

const SalesDetailsModel = ({ saleId, setSaleId, branchId }) => {
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  const [saleDetails, setSaleDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [selectedDesktopTag, setSelectedDesktopTag] = useState("Sales Details");

  useEffect(() => {
    setIsError(false);
    setErrorMessage("");
    setSaleDetails(null);
    setSelectedDesktopTag("Sales Details");
    if (saleId) {
      setLoading(true);
      fetchSaleDetails(saleId, branchId)
        .then((res) => {
          if (res.data?.sale_id === saleId) {
            setSaleDetails(res.data);
          } else {
            setSaleDetails(null);
          }
        })
        .catch((err) => {
          setIsError(true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [saleId]);

  useEffect(() => {
    if (saleId) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [saleId, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`sales-details-model ${isVisible ? "active" : ""}`}>
      <div className="header">
        <div
          className="back"
          onClick={() => {
            if (selectedDesktopTag === "Sales Details") {
              setSaleId(null);
            } else {
              setSelectedDesktopTag("Sales Details");
            }
          }}
        >
          <FaAngleLeft />
        </div>
        <p>{selectedDesktopTag}</p>
      </div>

      {saleDetails ? (
        <>
          {selectedDesktopTag === "Sales Details" && (
            <SalesDetails
              desktopView={true}
              sale={saleDetails}
              setSelectedDesktopTag={setSelectedDesktopTag}
              setSelectedSale={setSaleDetails}
            />
          )}

          {selectedDesktopTag === "PDF" && <PDF id={saleDetails?.id} />}

          {selectedDesktopTag === "Select Customer For Sale" && (
            <Customer
              isSale={true}
              sale={saleDetails}
              desktopView={true}
              setSelectedDesktopTag={setSelectedDesktopTag}
              setSelectedSale={setSaleDetails}
            />
          )}

          {selectedDesktopTag === "Add Customer For Sale" && (
            <AddCustomer
              isSale={true}
              sale={saleDetails}
              desktopView={true}
              setSelectedDesktopTag={setSelectedDesktopTag}
              setSelectedSale={setSaleDetails}
            />
          )}
        </>
      ) : (
        <div className="error-container">
          {loading && !isError ? (
            <>
              <RiLoaderLine className="rotate" />
              <p>Loading Sales Details</p>
            </>
          ) : (
            <></>
          )}
          {isError && !loading ? (
            <>
              <BiSolidErrorCircle className="danger" />
              <p>{errorMessage || "Error while fetching sales details."}</p>
            </>
          ) : (
            <></>
          )}
          {!loading && !isError ? (
            <>
              <TbHourglassEmpty />
              <p>Sales details not found.</p>
            </>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

const ProductActivity = ({ productId, branchId, orgIsAllowed, setSaleId }) => {
  const [loading, setLoading] = useState(false);
  const [activities, setActivities] = useState(null);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const groupLogsByDate = (dataArray) => {
    const groups = dataArray.reduce((acc, log) => {
      const logDate = parseISO(log?.updated_at);
      let group = "";

      if (isToday(logDate)) {
        group = "Today";
      } else if (isYesterday(logDate)) {
        group = "Yesterday";
      } else {
        // group = format(orderDate, "dd/MM/yyyy hh:mm a");
        group = format(logDate, "dd/MM/yyyy");
      }

      if (!acc[group]) {
        acc[group] = [];
      }

      acc[group].push(log);
      return acc;
    }, {});

    return groups;
  };

  useEffect(() => {
    setIsError(false);
    setErrorMessage("");
    setSaleId(null);
    if (productId && orgIsAllowed?.exists) {
      setLoading(true);

      fetchProductActivities(productId, branchId)
        .then((res) => {
          if (res.data?.length > 0) {
            const grouped_logs = groupLogsByDate(res.data);
            setActivities(grouped_logs);
          } else {
            setActivities(null);
          }
        })
        .catch((err) => {
          setActivities(null);
          setIsError(true);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setActivities(null);
      if (!orgIsAllowed?.exists) {
        setIsError(true);
        setErrorMessage("Your organization is not allowed to track stocks");
      }
    }
  }, [productId, branchId]);

  return (
    <>
      {loading || isError || !activities ? (
        <div className="error-container">
          {loading && !isError ? (
            <>
              <RiLoaderLine className="rotate" />
              <p>Loading Product's Activities</p>
            </>
          ) : (
            <></>
          )}
          {isError && !loading ? (
            <>
              <BiSolidErrorCircle className="danger" />
              <p>
                {errorMessage || "Error while fetching product's activities."}
              </p>
            </>
          ) : (
            <></>
          )}
          {!loading && !isError ? (
            <>
              <TbHourglassEmpty />
              <p>No activities found for this product.</p>
            </>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <>
          {Object.keys(activities).map((group, i) => {
            return (
              <div className="item-group" key={i}>
                <p className="title">{group}</p>
                <div className="lists">
                  {activities[group]?.map((item, index) => {
                    const attributes = item?.properties?.attributes || {};
                    return (
                      <div
                        className={`item ${
                          attributes?.sale_receipt_id ? "cursor" : ""
                        }`}
                        key={index}
                        onClick={() => {
                          if (attributes?.sale_receipt_id) {
                            setSaleId(attributes?.sale_receipt_id);
                          }
                        }}
                      >
                        <div className="left">
                          <p
                            className={`text-with-svg ${
                              attributes?.changed_stock > 0
                                ? "primary"
                                : "danger"
                            }`}
                          >
                            {item?.event === "created" ? (
                              <FaArrowUpLong className="up" />
                            ) : item?.event === "deleted" ? (
                              <FaMinus className="danger" />
                            ) : (
                              <>
                                {attributes?.changed_stock > 0
                                  ? `+${attributes?.changed_stock}`
                                  : `${attributes?.changed_stock}`}
                                {attributes?.changed_stock > 0 ? (
                                  <FaCaretUp />
                                ) : (
                                  <FaCaretDown />
                                )}
                              </>
                            )}
                          </p>

                          <div className="details">
                            <p className="title">{attributes?.activity}</p>
                            <span>
                              {`${
                                attributes?.sale_receipt_id
                                  ? `#${attributes?.sale_receipt_id} | `
                                  : ""
                              } ${
                                item?.updated_at
                                  ? `${format(
                                      new Date(item?.updated_at),
                                      "hh:mm a"
                                    )} | `
                                  : ""
                              } ${item?.causer?.name}`}
                            </span>
                          </div>
                        </div>
                        <div className="right">
                          <span>Remaining</span>
                          <p>{attributes?.current_stock}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

const CategorySelectionModel = ({
  open,
  setOpen,
  options,
  selectedOptions,
  setSelectedOptions,
  setOpenAddCategory,
}) => {
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  const [newSelectedOptions, setNewSelectedOptions] = useState([]);

  const [newOptions, setNewOptions] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [debounceKeyword, setDebounceKeyword] = useState("");

  const [changesDetected, setChangesDetected] = useState(false);

  useEffect(() => {
    let isDifferent = false;
    if (newSelectedOptions?.length !== selectedOptions?.length) {
      return setChangesDetected(true);
    }
    newSelectedOptions?.forEach((el) => {
      const exists = selectedOptions?.find((item) => item?.id === el?.id);

      if (!exists) {
        isDifferent = true;
      }
    });
    setChangesDetected(isDifferent);
  }, [selectedOptions, newSelectedOptions, open]);

  useEffect(() => {
    setNewSelectedOptions(selectedOptions);
  }, [open, options]);

  useEffect(() => {
    if (debounceKeyword) {
      const regex = new RegExp(searchKeyword, "i");
      const filteredCategories = options.filter((category) =>
        regex.test(category?.name)
      );
      if (filteredCategories?.length < 1) {
        toast.dismiss();
        toast.error(`No categories found for ${searchKeyword}.`);
      }

      setNewOptions(filteredCategories);
    } else {
      setNewOptions(options);
    }
  }, [open, debounceKeyword]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceKeyword(searchKeyword);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKeyword]);

  const handleChange = () => {
    setSelectedOptions(newSelectedOptions);
    setOpen(false);
  };

  const handleAddCategory = (item) => {
    const tempArray = [...newSelectedOptions];
    const exists = tempArray?.findIndex((el) => el?.id === item?.id);

    if (exists !== -1) {
      tempArray.splice(exists, 1);
    } else {
      tempArray.push(item);
    }

    setNewSelectedOptions(tempArray);
  };

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
    setSearchKeyword("");
    setDebounceKeyword("");
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`category-selection-option ${isVisible ? "active" : ""}`}>
      <div className="header">
        <div
          className="back"
          onClick={() => {
            setOpen(false);
          }}
        >
          <FaAngleLeft />
        </div>
        <p>Category</p>

        <div
          className="last-tag-svg"
          onClick={() => {
            setOpenAddCategory(true);
          }}
        >
          <FaPlus />
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          setSearchKeyword(e.target.keyword.value);
        }}
        className="categories-search"
      >
        <div className="inputs">
          <input
            defaultValue={searchKeyword}
            type="text"
            name="keyword"
            placeholder="Search"
            onChange={(e) => {
              setSearchKeyword(e.target.value);
            }}
          />
          <button type="submit">
            <IoSearch />
          </button>
        </div>
      </form>

      <div className="options">
        {newOptions?.map((el, i) => {
          const selected = newSelectedOptions?.find(
            (item) => item?.id === el?.id
          );

          return (
            <div
              className="item"
              key={i}
              onClick={() => {
                handleAddCategory(el);
              }}
            >
              <p>{el?.name}</p>
              <span>{selected ? <FaCheck /> : <></>}</span>
            </div>
          );
        })}
      </div>

      <div className="floating-button">
        <CustomButton
          name={"Save"}
          color={"primary"}
          type={"button"}
          handleSubmit={() => {
            handleChange();
          }}
          bigButton={true}
          disabled={!changesDetected}
        />
      </div>
    </div>
  );
};

const AddCategory = ({
  openAddCategory,
  setOpenAddCategory,
  organizationId,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const [submitting, setSubmitting] = useState(false);

  const clearForm = () => {
    reset({
      name: "",
      description: "",
    });
  };

  const handleAddCategory = (data) => {
    setSubmitting(true);
    const categoryData = {
      organization_id: organizationId,
      name: data.name,
      description: data.description,
    };

    addCategory(categoryData)
      .then((res) => {
        toast.dismiss();
        toast.success("Category added successfully.");
        dispatch(addNewCategory({ category: res.data }));
        setOpenAddCategory(false);
        clearForm();
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          if (err?.response?.data?.message === "User not authorized!") {
            toast.dismiss();
            toast.error(
              "You do not have sufficient permissions to perform this action. Please contact your administrator."
            );
          } else {
            toast.dismiss();
            toast.error(`${err?.response?.data?.message}`);
          }
        } else {
          toast.dismiss();
          toast.error("Category adding failed.");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (openAddCategory) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [openAddCategory, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleAddCategory)}
      className={`add-category ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">Add Category</h1>

      <div className="form-content">
        <InputField
          name={"name"}
          type={"text"}
          label={"Category Name"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />

        <InputField
          name={"description"}
          type={"text"}
          label={"Description"}
          required={false}
          textArea={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpenAddCategory(false);
            clearForm();
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Save"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};
